import { AppSections } from "./AppSections";
import { SectionMenu } from "./components/SectionMenu";
import { SectionMenuItem } from "./components/SectionMenuItem";
SectionMenu.SectionMenuItem = SectionMenuItem;

export { SectionMenu, AppSections };
